import { combineReducers } from 'redux';
import authReducer from '../features/auth/authSlice';
import branchReducer from '../features/branches/branchSlice';
import studentReducer from '../features/student/studentSlice';
import paymentReducer from '../features/payments/PaymentSlice';
import notificationReducer from '../features/notifications/notificaitonSlice';
import classReducer from '../features/classes/ClassSlice';
import attendanceReducer from '../features/attendance/AttendanceSlice';
import subjectReducer from '../features/subjects/subjectsSlice';
import examinationReducer from '../features/examinations/examinationSlice';
import examScheduleReducer from '../features/schedule/examScheduleSlice';
import gradeReducer from '../features/grades/gradeSlice';
import marksReducer from '../features/marks/marksSlice';
import mobileReducer from '../features/mobile/mobileSlice';
import dashboardReducer from '../features/dashboard/dashboardSlice';
import HistoryReducer from '../features/history/HistorySlice';
const appReducer = combineReducers({
  auth: authReducer,
  branches: branchReducer,
  students: studentReducer,
  payments: paymentReducer,
  notification: notificationReducer,
  classes: classReducer,
  attendance: attendanceReducer,
  subjects: subjectReducer,
  examinations: examinationReducer,
  examSchedules: examScheduleReducer,
  grades: gradeReducer,
  marks: marksReducer,
  mobile: mobileReducer,
  dashboard: dashboardReducer,
  history: HistoryReducer,
});

const rootReducer = (state, action) => {
  if (action.type === 'RESET_STATE') {
    state = undefined;
  }
  return appReducer(state, action);
};

export const resetAppState = () => ({ type: 'RESET_STATE' });

export default rootReducer;
